import { render, staticRenderFns } from "./DocumentExtensionIcon.vue?vue&type=template&id=1efefa34"
import script from "./DocumentExtensionIcon.vue?vue&type=script&lang=ts"
export * from "./DocumentExtensionIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efefa34')) {
      api.createRecord('1efefa34', component.options)
    } else {
      api.reload('1efefa34', component.options)
    }
    module.hot.accept("./DocumentExtensionIcon.vue?vue&type=template&id=1efefa34", function () {
      api.rerender('1efefa34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentExtensionIcon.vue"
export default component.exports